<template>
    <Series />
</template>
<script>
import Series from '@/components/Series.vue';

export default {
    name: 'SeriesAdd',
    components: {
        Series
    },
}
</script>
